import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import { tap, map, flatMap, concatMap, scan, startWith, catchError, filter, shareReplay } from 'rxjs/operators';
import { from, combineLatest, EMPTY } from 'rxjs';
import { AsistenciaService } from '../_services/asistencia.service';
import { MapaCurricularService } from '../../estudio/mapa-curricular/_services/mapa-curricular.service';
import {MY_FORMATS} from '../../../_models/moment-formats';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReporteGeneralService } from '../reporte-general/reporte-general.service';
import { CursosService } from 'src/app/_services/cursos.service';
import { DynamicBarService } from 'src/app/_components/dynamic-bar/dynamic-bar.service';
import { EstudioService } from '../../estudio/estudio.service';
import { ReporteDireccionCursoNotificarComponent } from '../reporte-direccion-curso-notificar/reporte-direccion-curso-notificar.component';
import { MatDialog } from '@angular/material/dialog';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { HorarioService } from 'src/app/_services/horario.service';
import { MatriculaService } from '../../matricula/matricula.service';

@Component({
  selector: 'app-reporte-direccion-curso',
  standalone: false,
  templateUrl: './reporte-direccion-curso.component.html',
  styleUrls: ['./reporte-direccion-curso.component.scss'],
  providers: [
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
  ],
})

export class ReporteDireccionCursoComponent implements OnInit {

  checkForm = new UntypedFormGroup({});

  fechaSeleccionada$ = this.route.paramMap.pipe(
    map(data => {
      return data.get('fecha') ? data.get('fecha') : moment().format('YYYY-MM-DD');
    }),
    tap(data => {
      this.fechaSeleccionada = data;
      this.date.setValue(this.fechaSeleccionada);
    })
  );

  areaSeleccionada$ = this.route.paramMap.pipe(
    map(data => {
      return data.get('area') ? +data.get('area') : -1;
    }),
    tap(data => {
      this.areaSeleccionada = data;
    })
  );

  fechaSeleccionada: string;

  areaSeleccionada: number;

  cursos$ = this.cursosService.cursos$;

  areas$ = this.estudioService.getAreas().pipe(
    map(data => {
      data.push({nombre: 'Todos', orden: -1});
      data.push({nombre: 'Dirección de curso', orden: 0});
      data.push({nombre: 'Materias del día', orden: -1});
      return data;
      // return data.filter(item => item.orden < 13 || item.orden === 39);
    }),
    shareReplay(1)
  );

  dataSource = null;

  listWarningDates = [];
  listWarningDates$ = this.reporteGeneralService.warningDates$.pipe(
    map(dates =>
      dates.map(date => {
        this.listWarningDates.push(moment(date.substring(0, 10)));
        return moment(date.substring(0, 10));
      })
    )
  );

  filtroCursos = new UntypedFormGroup({
    curso: new UntypedFormControl(0),
    nombre: new UntypedFormControl(''),
    materia: new UntypedFormControl(''),
    estado: new UntypedFormControl(0)
  });

  materiasDeHoy$ = this.fechaSeleccionada$.pipe(
    flatMap(data => {
      return this.horarioService.getHorarioDia(data);
    })
  );


  date = new UntypedFormControl('');
  dateClass = (d: Date) => {
    const date = moment(d).format('YYYY-MM-DD');
    return this.listWarningDates.find(pendienteDate => pendienteDate.format('YYYY-MM-DD').indexOf(date) > -1) ? 'warning-date' : undefined;
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private asistenciaService: AsistenciaService,
    private mapaService: MapaCurricularService,
    private reporteGeneralService: ReporteGeneralService,
    private cursosService: CursosService,
    private estudioService: EstudioService,
    private barService: DynamicBarService,
    private matDialogRef: MatDialog,
    private customAlertService: CustomAlertService,
    private horarioService: HorarioService) {
      router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.barService.setBarra('asistencia-reporte-cursos-barra');
    this.titleService.setTitle('MiGLM');
    const filtro$ = this.filtroCursos.valueChanges.pipe(
      startWith(this.filtroCursos.value)
    );
    const materiasDC$ = combineLatest([this.mapaService.getMCP(),
      this.fechaSeleccionada$,
      this.areaSeleccionada$,
      this.estudioService.getPeriodoActual(false)
    ]).pipe(
      map(([mcp, fecha, area, periodo]) => {
        if (area === -1) {
          return {
            mcp: [],
            fecha: fecha
          };
        }
        return {
          mcp: mcp.filter(
            item => {
              if (area === -1) {
                return true;
              } else if (area === 0) {
                return item.nombre === 'Elementos Unificadores' ||
                  item.nombre === 'Desarrollo Personal';
              } else {
                return item.areaOrden === area && (item.tipoSemestre === 0 || item.tipoSemestre === periodo['tipoSemestre']);
              }
            }
            ),
          fecha: fecha
        };
      }),
      flatMap(data => {
        this.checkForm = new UntypedFormGroup({});
        return this.asistenciaService.getAsistenciaDia(data.mcp.map(item => item.id).join(','), data.fecha).pipe(
          map(materias => {
            materias.forEach(materia => {
              this.checkForm.addControl(materia.materiaCursoPeriodoID, new UntypedFormControl(false));
            });
            return materias;
             // .sort((a, b) => a.orden - b.orden);
          }));
      }),
    );

    const materiasFiltradas$ = combineLatest([materiasDC$, filtro$]).pipe(
      map(([list, filtro]) => {
        return list.filter(item => {
          const nombres: string = filtro['nombre'];
          let filterByNombres = false;
          if (nombres) {
            item.profesores.forEach(profesor => {
              nombres.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ').forEach(element => {
                if (profesor.apellidosNombres.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(element)) {
                  filterByNombres = true;
                }
              });
            });
          } else {
            filterByNombres = true;
          }
          const materia: string = filtro['materia'];
          let filterByMateria = true;
          if (materia) {
            materia.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ').forEach(element => {
              if (!item.nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().includes(element)) {
                filterByMateria = false;
              }
            });
          }
          return (+filtro.curso === 0 || item.curso.id === filtro.curso) && filterByMateria && filterByNombres &&
            (+filtro.estado === 0 ||
              ((item.horasClase > 0 && +filtro.estado === 1) || (item.horasClase === 0 && +filtro.estado === 2)));
        });
      })
    );

    materiasFiltradas$.subscribe(res => {
      this.dataSource = res;
    });

  }

  changeDate(date) {
    this.router.navigate(['/', 'asistencia', 'reporte', 'materias',
      {area: this.areaSeleccionada, fecha: moment(date).format('YYYY-MM-DD')}]);
  }

  asistencias(horas: number) {
    return horas > 0 ? 'Asistencia tomada' : 'Asistencia sin registrar';
  }

  alumnosRetardo(alumnos: any) {
    let count = 0;
    alumnos.forEach(element => {
      element.asistencias.forEach(asistencia => {
        if ([2, 3, 4, 5, 6].includes(asistencia.tipoID)) {
          count++;
        }
      });
    });
    return count;
  }

  alumnosAusentes(alumnos: any) {
    let count = 0;
    alumnos.forEach(element => {
      element.asistencias.forEach(asistencia => {
        if ([7, 8, 9, 10, 11].includes(asistencia.tipoID)) {
          count++;
        }
      });
    });
    return count;
  }

  selectAll(value: boolean, obj: any[]) {
    obj.forEach(item => {
      this.checkForm.get('' + item.materiaCursoPeriodoID).setValue(value);
    });
  }

  navigate(id: number) {
    const url = this.router.createUrlTree(['/asistencia/materia', id]);
    window.open(url.toString(), '_blank');
  }

  navegarArea(area: any) {
    this.router.navigate(['/', 'asistencia', 'reporte', 'materias', {area: area.orden, fecha: moment(this.fechaSeleccionada).format('YYYY-MM-DD')}]);
  }

  nombreArea(areas: any[]) {
    return areas.find(item => item.orden === this.areaSeleccionada).nombre.toLowerCase();
  }

  listaMaterias(): any[] {
    const resp = [];
    const value = this.checkForm.value;
    for (const property in value) {
      if (value.hasOwnProperty(property)) {
        if (value[property]) {
          resp.push(+property);
        }
      }
    }
    return resp;
  }

  notificar() {
    const materiasIds = this.listaMaterias();
    if (this.listaMaterias().length > 0) {
      this.matDialogRef.open(ReporteDireccionCursoNotificarComponent, {
        width: '100%',
        height: '100%',
        maxWidth: '100vw !important',
        maxHeight: 'calc(100vh -64px)',
        position: { bottom: '0'},
        // width: '55%',
        disableClose: true,
        data: {
          materias: this.dataSource.filter(item => materiasIds.includes(+item.materiaCursoPeriodoID)),
          fechaAsistencia: this.fechaSeleccionada
        }
      });
    } else {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `Seleccione al menos una materia a notificar.`
      });
    }
  }
}
